"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  shell: {
    componentTitle: 'Uitvoeringsconfiguraties',
    incompletePropsMessage: 'Niet genoeg informatie verstrekt, vul alle verplichte velden voor testbestellingen in.'
  },
  selectedConfigurationDisplay: {
    selectedConfigurationLabel: 'GESELECTEERDE CONFIGURATIE:',
    noSelectedConfigurationLabel: 'Selecteer een configuratie:',
    clearButton: 'Duidelijke selectie'
  },
  fulfillmentConfigurationList: {
    actions: {
      error500: 'Er is iets misgegaan bij het ophalen van de lijst met uitvoeringsconfiguraties. ' + 'U kunt op Opnieuw proberen drukken om te zien of het wordt opgelost.',
      permissionsError: 'Het lijkt erop dat u geen toestemming heeft om deze uitvoeringsconfiguraties te bekijken. ' + 'Neem contact op met Platformondersteuning om toegang te krijgen.',
      unknownError: 'Een onbekende fout is opgetreden. Probeer het a.u.b. opnieuw.'
    },
    table: {
      nameHeader: 'Naam uitvoeringsconfiguratie'
    },
    selectVersionButton: 'Selecteer versie'
  },
  fulfillmentConfigurationErrorPage: {
    noAvailableFulfillmentConfigurations: {
      titleText: 'Er zijn geen leveringsconfiguraties beschikbaar voor dit product.',
      productAssociationsSuggestion: 'Kijk jouw ... Na ',
      productAssociationsLink: 'Productverenigingen',
      fulfillmentConfigurationsSuggestion: 'Maak een nieuw ',
      fulfillmentConfigurationsLink: 'Fulfillment-configuratie',
      emailSuggestion: 'Meer ondersteuning nodig? Contact ',
      emailLink: 'platformsupport@cimpress.com',
      tryAgainText: 'Enkele wijzigingen aangebracht? Klik hier om het opnieuw te proberen.'
    },
    error: {
      errorTitle: 'Er is een fout opgetreden bij het laden van de uitvoeringsconfiguraties'
    },
    reloadButtonText: 'Herlaad'
  },
  search: {
    searchFieldLabel: 'Zoek configuraties'
  },
  versionsList: {
    table: {
      moreInfoButton: 'Meer informatie',
      rowContentsHeader: 'Versie',
      noVersionsText: 'Geen versies gevonden'
    },
    backButton: 'Terug'
  }
};
exports["default"] = _default;